var Afghanistan = "아프가니스탄";
var Albania = "알바니아";
var Algeria = "알제리";
var Andorra = "안도라";
var Angola = "앙골라";
var Anguilla = "앵귈라";
var Antarctica = "남극 대륙";
var Argentina = "아르헨티나";
var Armenia = "아르메니아";
var Aruba = "아루바";
var Australia = "오스트레일리아";
var Austria = "오스트리아";
var Azerbaijan = "아제르바이잔";
var Bahamas = "바하마";
var Bahrain = "바레인";
var Bangladesh = "방글라데시";
var Barbados = "바베이도스";
var Belarus = "벨라루스";
var Belgium = "벨기에";
var Belize = "벨리즈";
var Benin = "베냉";
var Bermuda = "버뮤다";
var Bhutan = "부탄";
var Bolivia = "볼리비아";
var Botswana = "보츠와나";
var Brazil = "브라질";
var Bulgaria = "불가리아";
var Burundi = "부룬디";
var Cambodia = "캄보디아";
var Cameroon = "카메룬";
var Canada = "캐나다";
var Chad = "차드";
var Chile = "칠레";
var China = "중국";
var Colombia = "콜롬비아";
var Comoros = "코모로스";
var Congo = "콩고";
var Croatia = "크로아티아";
var Cuba = "쿠바";
var Cyprus = "키프로스";
var Denmark = "덴마크";
var Djibouti = "지부티";
var Dominica = "도미니카";
var Ecuador = "에콰도르";
var Egypt = "이집트";
var Eritrea = "에리트레아";
var Estonia = "에스토니아";
var Ethiopia = "에티오피아";
var Fiji = "피지";
var Finland = "핀란드";
var France = "프랑스";
var Gabon = "가봉";
var Gambia = "감비아";
var Georgia = "조지아";
var Germany = "독일";
var Ghana = "가나";
var Gibraltar = "지브롤터";
var Greece = "그리스";
var Greenland = "그린란드";
var Grenada = "그레나다";
var Guadeloupe = "과들루프";
var Guam = "괌";
var Guatemala = "과테말라";
var Guernsey = "건지";
var Guinea = "기니";
var Guyana = "가이아나";
var Haiti = "아이티";
var Honduras = "온두라스";
var Hungary = "헝가리";
var Iceland = "아이슬란드";
var India = "인도";
var Indonesia = "인도네시아";
var Iraq = "이라크";
var Ireland = "아일랜드";
var Israel = "이스라엘";
var Italy = "이탈리아";
var Jamaica = "자메이카";
var Japan = "일본";
var Jersey = "저지";
var Jordan = "조던";
var Kazakhstan = "카자흐스탄";
var Kenya = "케냐";
var Kiribati = "키리바시";
var Kuwait = "쿠웨이트";
var Kyrgyzstan = "키르기스스탄";
var Latvia = "라트비아";
var Lebanon = "레바논";
var Lesotho = "레소토";
var Liberia = "라이베리아";
var Libya = "리비아 아랍 자마히리야";
var Liechtenstein = "리히텐슈타인";
var Lithuania = "리투아니아";
var Luxembourg = "룩셈부르크";
var Macao = "모나코";
var Madagascar = "마다가스카르";
var Malawi = "말라위";
var Malaysia = "말레이시아";
var Maldives = "몰디브";
var Mali = "말리";
var Malta = "몰타";
var Martinique = "마르티니크";
var Mauritania = "모리타니아";
var Mauritius = "모리셔스";
var Mayotte = "마요트";
var Mexico = "멕시코";
var Monaco = "모나코";
var Mongolia = "몽골";
var Montenegro = "몬테네그로";
var Montserrat = "몬트세라트";
var Morocco = "모로코";
var Mozambique = "모잠비크";
var Myanmar = "미얀마";
var Namibia = "나미비아";
var Nauru = "나우루";
var Nepal = "네팔";
var Netherlands = "네덜란드";
var Nicaragua = "니카라과";
var Niger = "니제르";
var Nigeria = "나이지리아";
var Niue = "니우에";
var Norway = "노르웨이";
var Oman = "오만";
var Pakistan = "파키스탄";
var Palau = "팔라우";
var Panama = "파나마";
var Paraguay = "파라과이";
var Peru = "페루";
var Philippines = "필리핀";
var Pitcairn = "핏케언";
var Poland = "폴란드";
var Portugal = "포르투갈";
var Qatar = "카타르";
var Romania = "루마니아";
var Rwanda = "르완다";
var Samoa = "사모아";
var Senegal = "세네갈";
var Serbia = "세르비아";
var Seychelles = "세이셸";
var Singapore = "싱가포르";
var Slovakia = "슬로바키아";
var Slovenia = "슬로베니아";
var Somalia = "소말리아";
var Spain = "스페인";
var Sudan = "수단";
var Suriname = "수리남";
var Swaziland = "스와질란드";
var Sweden = "스웨덴";
var Switzerland = "스위스";
var Taiwan = "대만";
var Tajikistan = "타지키스탄";
var Thailand = "태국";
var Togo = "토고";
var Tokelau = "토켈라우";
var Tonga = "통가";
var Tunisia = "튀니지";
var Turkey = "터키";
var Turkmenistan = "투르크메니스탄";
var Tuvalu = "투발루";
var Uganda = "우간다";
var Ukraine = "우크라이나";
var Uruguay = "우루과이";
var Uzbekistan = "우즈베키스탄";
var Vanuatu = "바누아투";
var Venezuela = "베네수엘라";
var Yemen = "예멘";
var Zambia = "잠비아";
var Zimbabwe = "짐바브웨";
var countries = {
	"Country or region": "국가 또는 지역",
	"United States": "미국",
	Afghanistan: Afghanistan,
	"Åland Islands": "올란드 제도",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "미국령 사모아",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "앤티가 바부다",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "보스니아 헤르체고비나",
	Botswana: Botswana,
	"Bouvet Island": "부베 섬",
	Brazil: Brazil,
	"British Indian Ocean Territory": "영국령 인도양 식민지",
	"Brunei Darussalam": "브루나이 다루살람",
	Bulgaria: Bulgaria,
	"Burkina Faso": "부르키나파소",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "케이프 베르데",
	"Cayman Islands": "케이먼 제도",
	"Central African Republic": "중앙아프리카공화국",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "크리스마스 섬",
	"Cocos (Keeling) Islands": "코코스(킬링) 제도",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "콩고 민주공화국",
	"Cook Islands": "쿡 제도",
	"Costa Rica": "코스타리카",
	"Côte d'Ivoire": "코트디부아르",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "체코공화국",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "도미니카공화국",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "엘살바도르",
	"Equatorial Guinea": "적도 기니",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "포클랜드 제도(말비나스)",
	"Faroe Islands": "페로 제도",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "프랑스령 기아나",
	"French Polynesia": "프랑스령 폴리네시아",
	"French Southern Territories": "프랑스 남주 지역",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "기니비사우",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "허드 섬 및 맥도날드 제도",
	"Holy See (Vatican City State)": "교황청(바티칸 시국)",
	Honduras: Honduras,
	"Hong Kong": "홍콩",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "이란 이슬람공화국",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "맨 섬",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "조선민주주의 인민공화국",
	"Korea, Republic of": "대한민국",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "라오인민민주주의공화국",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "구 유고슬라비아 마케도니아 공화국",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "마셜 제도",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "미크로네시아 연방공화국",
	"Moldova, Republic of": "몰도바",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "네덜란드령 앤틸리스",
	"New Caledonia": "뉴칼레도니아",
	"New Zealand": "뉴질랜드",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "노퍽 섬",
	"Northern Mariana Islands": "북마리아나 제도",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "팔레스타인 자치정부",
	Panama: Panama,
	"Papua New Guinea": "파푸아 뉴기니",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "푸에르토리코",
	Qatar: Qatar,
	"Réunion": "레위니옹",
	Romania: Romania,
	"Russian Federation": "러시아 연방",
	Rwanda: Rwanda,
	"Saint Helena": "세인트헬리나",
	"Saint Kitts and Nevis": "세인트키츠 네비스",
	"Saint Lucia": "세인트루시아",
	"Saint Pierre and Miquelon": "생피에르 미클롱",
	"Saint Vincent and The Grenadines": "세인트빈센트 그레나딘",
	Samoa: Samoa,
	"San Marino": "산마리노",
	"Sao Tome and Principe": "상토메 프린시페",
	"Saudi Arabia": "사우디아라비아",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "시에라리온",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "솔로몬 제도",
	Somalia: Somalia,
	"South Africa": "남아프리카 공화국",
	"South Georgia and The South Sandwich Islands": "사우스조지아 사우스샌드위치 제도",
	Spain: Spain,
	"Sri Lanka": "스리랑카",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "스발바르 얀마웬",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "시리아 아랍공화국",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "탄자니아합중국",
	Thailand: Thailand,
	"Timor-Leste": "티모르레스트",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "트리니다드 토바고",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "터크스 카이코스 제도",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "아랍에미리트연합",
	"United Kingdom": "영국",
	"United States Minor Outlying Islands": "미국령 군소 제도",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "베트남",
	"Virgin Islands, British": "영국령 버진 아일랜드",
	"Virgin Islands, U.S.": "미국령 버진 아일랜드",
	"Wallis and Futuna": "윌리스 푸투나",
	"Western Sahara": "서사하라",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
